import { useEffect, useState } from 'react';

export const useCountdown = (targetTime) => {
  const calculateTimeLeft = () => {
    const difference = Number(targetTime) - Number(new Date());

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }

    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)) || 0,
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24) || 0,
      minutes: Math.floor((difference / 1000 / 60) % 60) || 0,
      seconds: Math.floor((difference / 1000) % 60) || 0,
    };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft);

  useEffect(() => {
    const difference = Number(targetTime) - Number(new Date());
    if (difference <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetTime]);

  return timeLeft;
};